import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';


  export const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: "#22419e",
      // '&:hover': {
      //   backgroundColor: "#22419e",
      // },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: "#22419e",
    },
  }));